var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"22","height":"22","viewBox":"0 0 22 22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{attrs:{"x":"0.5","y":"0.5","width":"21","height":"21","rx":"7.5","stroke":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }